import { connect } from 'react-redux'

import MessageItem from '../../components/messages/message-item'

function mapStateToProps (state, ownProps) {
  const message = state.messages[ownProps.messageId]
  const user = state.users[message.user]
  const dismissedBy = state.users[message.dismissedBy]

  return {
    message,
    user,
    dismissedBy
  }
}

export default connect(mapStateToProps)(MessageItem)



// WEBPACK FOOTER //
// ./src/containers/messages/message-item-container.js